import Intercom, { shutdown as intercomShutdown } from "@intercom/messenger-js-sdk"

export function useIntercom() {
  function updateIntercomWithUser(user?: Nullable<Partial<User>>) {
    const config = useConfig()
    const appId = config.NUXT_PUBLIC_INTERCOM_APP_ID

    if (!appId) {
      console.log("appId is not set")
      return
    }

    Intercom({
      app_id: appId,
      hide_default_launcher: false,
      email: user?.email,
      user_hash: user?.hash,
      id_number: user?.userDetails?.idNumber,
    })
  }

  function resetIntercom() {
    intercomShutdown()
    updateIntercomWithUser()
  }

  return {
    updateIntercomWithUser,
    resetIntercom,
  }
}
